var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import _cloneDeep from "lodash/cloneDeep";
import { LifeCycleEventName } from "../../constants/sdk";
import { BasePlugin, DefaultEventPlugin } from "../../plugins";
import ConsentModule from "../consent-module";
import { BaseInfoModule } from "../info-module";
import LoggingModule from "../logging-module";
import { BaseNotificationModule } from "../notification-module";
class LifeCycleModule {
  constructor() {
    this._thirdPartyMap = {};
    this._cleanUpPlugins = () => {
      if (this._pluginsMap) {
        Object.keys(this._pluginsMap).forEach((event) => {
          const lifeCycleEvent = event;
          const plugins = this._pluginsMap[lifeCycleEvent];
          if (plugins == null ? void 0 : plugins.length) {
            plugins.forEach((plugin) => {
              var _a;
              (_a = plugin == null ? void 0 : plugin.destruct) == null ? void 0 : _a.call(plugin);
            });
            delete this._pluginsMap[lifeCycleEvent];
          }
        });
      }
      this._defaultPlugin = null;
    };
    // intentionally use arrow function here to make sure this in dispatch is LifeCycleModule
    this.dispatch = (name, data) => __async(this, null, function* () {
      var _a;
      LoggingModule.info("[LifeCycleModule]: dispatch start");
      if (this._currentEvent.has(name)) {
        LoggingModule.error("[LifeCycleModule]: Dispatch is already in process", {
          currentEvent: [...this._currentEvent],
          upcomingEvent: name
        });
        return;
      }
      this._currentEvent.add(name);
      const relatedPlugins = (_a = this._pluginsMap) == null ? void 0 : _a[name];
      const promises = [];
      relatedPlugins.forEach((plugin) => {
        var _a2;
        if ((plugin == null ? void 0 : plugin[name]) && typeof plugin[name] === "function") {
          promises.push(
            (_a2 = plugin == null ? void 0 : plugin[name]) == null ? void 0 : _a2.call(plugin, {
              name,
              data: _cloneDeep(data),
              plugin
            })
          );
        }
      });
      try {
        yield Promise.all(promises);
      } catch (e) {
        LoggingModule.warn("[LifeCycleModule]: plugin callback error", e);
      }
      this._currentEvent.delete(name);
      LoggingModule.info("[LifeCycleModule]: dispatch finish");
    });
    // intentionally use arrow function here to make sure this in dispatch is LifeCycleModule
    this._dispatchAfterEvent = (name, result) => {
      LoggingModule.info("[LifeCycleModule]: dispatchAfterEvent");
      if (result instanceof Promise) {
        result.then((res) => {
          void this.dispatch(name, res);
        }).catch((e) => {
          void this.dispatch(name, e);
        });
      } else {
        void this.dispatch(name, result);
      }
    };
    this.addEventListener = (eventName, id, callback) => {
      var _a;
      (_a = this._defaultPlugin) == null ? void 0 : _a.addEventListener(eventName, id, callback);
    };
    this.removeEventListener = (eventName, id) => {
      var _a;
      (_a = this._defaultPlugin) == null ? void 0 : _a.removeEventListener(eventName, id);
    };
    if (!LifeCycleModule._instance) {
      LifeCycleModule._instance = this;
    }
    return LifeCycleModule._instance;
  }
  init(config) {
    this._entityKeys = config.entityKeys;
    this._currentEvent = /* @__PURE__ */ new Set();
    LoggingModule.info("[LifeCycleModule]: init");
    this._initPlugins(config);
    this._initModules(config);
    this._registerThirdParties(config);
  }
  _initModules(config) {
    var _a, _b;
    LoggingModule.info("[LifeCycleModule]: initModules");
    this._consentModule = new ConsentModule();
    this._consentModule.init(config);
    if ((_a = config == null ? void 0 : config.modules) == null ? void 0 : _a.notification) {
      if (config.modules.notification instanceof BaseNotificationModule) {
        this._notificationModule = config.modules.notification;
        this._notificationModule.init(config);
      } else {
        LoggingModule.warn(
          "[LifeCycleModule]: initModules - incorrect implementation of NotificationModule, will skip"
        );
      }
    }
    if ((_b = config == null ? void 0 : config.modules) == null ? void 0 : _b.info) {
      if (config.modules.info instanceof BaseInfoModule) {
        this._infoModule = config.modules.info;
        this._infoModule.init(config);
      } else {
        const msg = "[LifeCycleModule]: initModules - incorrect implementation of InfoModule";
        LoggingModule.error(msg);
      }
    } else {
      const msg = "[LifeCycleModule]: initModules - info module is required";
      LoggingModule.error(msg);
    }
  }
  // init plugins
  _initPlugins(config) {
    var _a;
    LoggingModule.info("[LifeCycleModule]: initPlugins");
    this._cleanUpPlugins();
    this._pluginsMap = Object.values(LifeCycleEventName).reduce((map, event) => {
      map[event] = [];
      return map;
    }, {});
    this._defaultPlugin = new DefaultEventPlugin();
    let plugins = [this._defaultPlugin];
    if ((_a = config.plugins) == null ? void 0 : _a.length) {
      plugins = plugins.concat(config.plugins);
    }
    const pluginNames = /* @__PURE__ */ new Set();
    plugins.forEach((plugin, index) => {
      var _a2;
      (_a2 = plugin.init) == null ? void 0 : _a2.call(plugin);
      this._registerPlugin(plugin, index, pluginNames);
    });
  }
  _registerPlugin(plugin, index, pluginNames) {
    var _a, _b, _c;
    const pluginName = (_a = plugin == null ? void 0 : plugin.getName) == null ? void 0 : _a.call(plugin);
    if (!pluginName) {
      LoggingModule.error(
        `[LifeCycleModule]: registerPlugin - Plugin on index ${index} is an invalid Plugin. Plugin should always have a unique name`,
        {
          index,
          plugin
        }
      );
      return;
    }
    if (pluginNames.has(pluginName)) {
      LoggingModule.error(`[LifeCycleModule]: registerPlugin - Duplicate Plugin ${pluginName}.`, {
        index,
        pluginName,
        plugin
      });
      return;
    }
    if (!(plugin instanceof BasePlugin)) {
      LoggingModule.error(`[LifeCycleModule]: registerPlugin - ${pluginName} incorrectly implements of Plugin.`, {
        index,
        pluginName,
        plugin
      });
      return;
    }
    LoggingModule.info(`[LifeCycleModule]: registerPlugin ${pluginName} start`);
    const events = (_c = (_b = plugin.getLifeCycleEvents) == null ? void 0 : _b.call(plugin)) == null ? void 0 : _c.filter((event) => event in LifeCycleEventName);
    if (events == null ? void 0 : events.length) {
      events.forEach((event) => {
        this._pluginsMap[event].push(plugin);
      });
    }
    LoggingModule.info(`[LifeCycleModule]: registerPlugin ${pluginName} finish`, {
      plugin: pluginName,
      events
    });
  }
  _registerThirdParties(config) {
    var _a, _b, _c;
    LoggingModule.info("[LifeCycleModule]: registerThirdParties");
    const { thirdParties } = (_a = config == null ? void 0 : config.modules) != null ? _a : {};
    this._thirdPartyMap = (_c = (_b = thirdParties == null ? void 0 : thirdParties.reduce) == null ? void 0 : _b.call(
      thirdParties,
      (map, thirdPartyRegister) => {
        const entityKeys = thirdPartyRegister.getRelatedEntities();
        for (const key of entityKeys) {
          if (!map[key]) {
            map[key] = [thirdPartyRegister];
          } else {
            map[key].push(thirdPartyRegister);
          }
        }
        return map;
      },
      {}
    )) != null ? _c : {};
  }
  _initThirdParties(newEntityMap) {
    var _a, _b;
    LoggingModule.info("[LifeCycleModule]: initThirdParties");
    if (newEntityMap && ((_a = Object.values(newEntityMap)) == null ? void 0 : _a.length)) {
      const entityKeysNeedToBeChecked = /* @__PURE__ */ new Set();
      const affectedThirdParties = /* @__PURE__ */ new Set();
      Object.values(newEntityMap).forEach((entity) => {
        var _a2;
        const thirdParties = (_a2 = this._thirdPartyMap) == null ? void 0 : _a2[entity == null ? void 0 : entity.key];
        if (thirdParties == null ? void 0 : thirdParties.length) {
          thirdParties.forEach((thirdParty) => {
            if (thirdParty) {
              const relatedEntities = thirdParty.getRelatedEntities();
              if (relatedEntities == null ? void 0 : relatedEntities.length) {
                relatedEntities.forEach((relatedEntityKey) => {
                  entityKeysNeedToBeChecked.add(relatedEntityKey);
                });
                affectedThirdParties.add(thirdParty);
              }
            }
          });
        }
      });
      if (affectedThirdParties.size) {
        const userInfo = this._getUserInfo();
        const approvedEntities = (_b = this._consentModule.getEntitiesWithApprovedRecord([...entityKeysNeedToBeChecked], userInfo)) != null ? _b : [];
        const approvedEntityMap = approvedEntities.reduce((map, consentEntity) => {
          map[consentEntity.key] = consentEntity;
          return map;
        }, {});
        for (const thirdParty of affectedThirdParties) {
          thirdParty.initThirdPartyModule(approvedEntityMap, this.dispatch, this._dispatchAfterEvent);
        }
      }
    }
  }
  fetch(arg) {
    LoggingModule.info("[LifeCycleModule]: fetch");
    return this.fetchUserInfo().then(() => {
      const promises = [
        this.shouldFetchConsentData() ? this.fetchConsentData(this._entityKeys) : Promise.resolve({}),
        this.shouldFetchNotificationData() ? this.fetchNotificationData(arg == null ? void 0 : arg.notificationParam) : Promise.resolve({})
      ];
      return Promise.all(promises).then((results) => {
        var _a;
        const [consentEntityMap, notificationData] = results;
        if (consentEntityMap && ((_a = Object.keys(consentEntityMap)) == null ? void 0 : _a.length)) {
          this._initThirdParties(consentEntityMap);
        }
        if (notificationData) {
          this._triggerNotification({
            notificationData,
            relatedConsentEntityMap: consentEntityMap
          });
        }
        return {
          consentData: consentEntityMap,
          notificationData
        };
      });
    }).catch((e) => {
      LoggingModule.error("[LifeCycleModule]: fetch failure", e);
    });
  }
  fetchUserInfo() {
    return __async(this, null, function* () {
      var _a, _b;
      LoggingModule.info("[LifeCycleModule]: fetchUserInfo");
      void this.dispatch(LifeCycleEventName.beforeFetchUserInfo);
      let userInfo = {};
      try {
        userInfo = yield (_b = (_a = this._infoModule) == null ? void 0 : _a.fetchUserInfo()) != null ? _b : Promise.resolve({});
      } catch (e) {
        LoggingModule.error("[LifeCycleModule]: fetchUserInfo - error", e);
      }
      void this.dispatch(LifeCycleEventName.afterFetchUserInfo, {
        userInfo
      });
      return userInfo;
    });
  }
  _getUserInfo() {
    var _a, _b;
    LoggingModule.info("[LifeCycleModule]: _getUserInfo");
    return (_b = (_a = this._infoModule) == null ? void 0 : _a.getUserInfo()) != null ? _b : {};
  }
  shouldFetchConsentData() {
    LoggingModule.info("[LifeCycleModule]: shouldFetchConsentData");
    return this._consentModule.shouldFetch();
  }
  fetchConsentData(entityKeys) {
    LoggingModule.info("[LifeCycleModule]: fetchConsentData");
    void this.dispatch(LifeCycleEventName.beforeFetchConsentData, {
      entityKeys
    });
    const userInfo = this._getUserInfo();
    return this._consentModule.fetch(entityKeys, userInfo).then((responseData) => {
      const { data } = responseData != null ? responseData : {};
      void this.dispatch(LifeCycleEventName.afterFetchConsentData, {
        entityKeys,
        data
      });
      return data;
    }).catch((e) => {
      LoggingModule.error("[LifeCycleModule]: fetchConsentData failure", e);
      void this.dispatch(LifeCycleEventName.afterFetchConsentData, {
        entityKeys,
        data: null,
        error: e
      });
    });
  }
  shouldFetchNotificationData() {
    var _a, _b;
    LoggingModule.info("[LifeCycleModule]: shouldFetchNotificationData");
    if (!this._notificationModule) {
      LoggingModule.info("[LifeCycleModule]: no notification module");
      return false;
    }
    return (_b = (_a = this._notificationModule) == null ? void 0 : _a.shouldFetch) == null ? void 0 : _b.call(_a);
  }
  fetchNotificationData(...notificationParams) {
    var _a, _b;
    LoggingModule.info("[LifeCycleModule]: fetchNotificationData");
    if (!this._notificationModule) {
      LoggingModule.info("[LifeCycleModule]: no notification module");
      return Promise.resolve(null);
    }
    void this.dispatch(LifeCycleEventName.beforeFetchNotificationData, {
      notificationParams
    });
    return (_b = (_a = this._notificationModule) == null ? void 0 : _a.fetch) == null ? void 0 : _b.call(_a, ...notificationParams).then((responseData) => {
      const { data } = responseData != null ? responseData : {};
      void this.dispatch(LifeCycleEventName.afterFetchNotificationData, {
        notificationParams,
        data
      });
      return data;
    }).catch((e) => {
      LoggingModule.error("[LifeCycleModule]: fetchNotificationData failure", e);
      void this.dispatch(LifeCycleEventName.afterFetchNotificationData, {
        notificationParams,
        data: null,
        error: e
      });
    });
  }
  getConsentRecord(entityKey) {
    LoggingModule.info("[LifeCycleModule]: getConsentRecord", {
      entityKey
    });
    const userInfo = this._getUserInfo();
    return this._consentModule.getRecord(entityKey, userInfo);
  }
  getConsentEntity(entityKey) {
    LoggingModule.info("[LifeCycleModule]: getConsentEntity", {
      entityKey
    });
    const userInfo = this._getUserInfo();
    return this._consentModule.getEntity(entityKey, userInfo);
  }
  getConsentRecords(entityKeys) {
    LoggingModule.info("[LifeCycleModule]: getConsentRecords", {
      entityKeys
    });
    const userInfo = this._getUserInfo();
    return this._consentModule.getRecords(entityKeys, userInfo);
  }
  getConsentEntities(entityKeys) {
    LoggingModule.info("[LifeCycleModule]: getConsentEntities", {
      entityKeys
    });
    const userInfo = this._getUserInfo();
    return this._consentModule.getEntities(entityKeys, userInfo);
  }
  updateConsentRecords(params, status, businessFlow) {
    return __async(this, null, function* () {
      LoggingModule.info("[LifeCycleModule]: updateConsentRecords", {
        params,
        status,
        businessFlow
      });
      void this.dispatch(LifeCycleEventName.beforeUpdateRecords, {
        params,
        status,
        businessFlow
      });
      let updatedEntityMap = {};
      const userInfo = this._getUserInfo();
      try {
        updatedEntityMap = yield this._consentModule.updateRecords(params, userInfo, status, businessFlow);
        void this.dispatch(LifeCycleEventName.afterUpdateRecords, {
          data: updatedEntityMap
        });
      } catch (e) {
        LoggingModule.error("[LifeCycleModule]: updateConsentRecords", e);
        void this.dispatch(LifeCycleEventName.afterUpdateRecords, {
          params,
          status,
          businessFlow,
          data: null,
          error: e
        });
      }
      this._initThirdParties(updatedEntityMap);
      return updatedEntityMap;
    });
  }
  getNotificationData() {
    LoggingModule.info("[LifeCycleModule]: getNotificationData");
    if (!this._notificationModule) {
      LoggingModule.info("[LifeCycleModule]: no notification module");
      return null;
    }
    return this._notificationModule.getData();
  }
  removeNotification(arg) {
    LoggingModule.info("[LifeCycleModule]: removeNotification");
    if (!this._notificationModule) {
      LoggingModule.info("[LifeCycleModule]: no notification module");
      return;
    }
    if (!this._notificationModule.canNotificationBeRemoved(arg)) {
      return;
    }
    void this.dispatch(LifeCycleEventName.beforeRemoveNotification, arg);
    const result = this._notificationModule.removeNotification(arg);
    this._dispatchAfterEvent(LifeCycleEventName.afterRemoveNotification, result);
  }
  notify(_a) {
    var _b = _a, { relatedEntityKeys = [] } = _b, rest = __objRest(_b, ["relatedEntityKeys"]);
    var _a2;
    LoggingModule.info("[LifeCycleModule]: notify");
    if (!this._notificationModule) {
      LoggingModule.info("[LifeCycleModule]: no notification module");
      return;
    }
    const relatedConsentEntities = (_a2 = this.getConsentEntities(relatedEntityKeys)) != null ? _a2 : [];
    const relatedConsentEntityMap = relatedConsentEntities.reduce(
      (map, entity) => {
        if (entity) {
          map[entity.key] = entity;
        }
        return map;
      },
      {}
    );
    this._triggerNotification(__spreadValues({
      relatedEntityKeys,
      notificationData: this.getNotificationData(),
      relatedConsentEntityMap
    }, rest));
  }
  _triggerNotification(data) {
    LoggingModule.info("[LifeCycleModule]: triggerNotification");
    if (!this._notificationModule) {
      LoggingModule.info("[LifeCycleModule]: no notification module");
      return;
    }
    if (!this._notificationModule.shouldNotify(data)) {
      return;
    }
    void this.dispatch(LifeCycleEventName.beforeNotify, data);
    const result = this._notificationModule.notify(data);
    this._dispatchAfterEvent(LifeCycleEventName.afterNotify, result);
  }
  destruct() {
    this._cleanUpPlugins();
    LoggingModule.info("[LifeCycleModule]: destruct");
  }
}
var LifeCycleModule_default = new LifeCycleModule();
export {
  LifeCycleModule_default as default
};
